export default {"src":"/_next/static/media/laptopLabelEmail.0e295889.svg","height":54,"width":72,"blurWidth":0,"blurHeight":0};